"use client";

import ErrorSymbol from "@/assets/icons/errorSign.svg";
import NoImageSrc from "@/assets/images/no_image.svg";
import { TranslationData } from "@/common/lib/types";
import Button from "@/components/ui/button/Button";
import Modal from "@/components/ui/modal_new/Modal";
import { useMediaQuery } from "@/hooks/useMediaQuery";
import { useGlobalStore } from "@/store/store";
import { getCloudinaryURL } from "@/utils/cloudinary";
import Image from "next/image";
import { useEffect, useState } from "react";
import Checkbox from "../ui/checkbox/Checkbox";
import Icon from "../ui/icon/Icon";
import TextField from "../ui/textField/TextField";

interface IProps {
  open: boolean;
  imgURL: string;
  onCancel: () => void;
  onAccept: (email: string) => void;
  translations: TranslationData;
  isNotifyMeLoading?: boolean;
}

const NotifyInStock = ({
  imgURL,
  onAccept,
  onCancel,
  open,
  translations,
  isNotifyMeLoading,
}: IProps) => {
  const { user } = useGlobalStore();

  const [isEmailChecked, setIsEmailChecked] = useState(true);
  const { pdp: pdpStaticContent } = translations || {};

  const [email, setEmail] = useState(user?.email ? user.email : "");

  const [isSmsChecked, setIsSmsChecked] = useState(true);
  const handleEmailChecked = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsEmailChecked(e?.target?.checked);
  };
  const [isEmailValid, setIsEmailValid] = useState(true);

  const handleSmsChecked = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsSmsChecked(e?.target?.checked);
  };

  const validateEmail = (email: string) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Basic email regex
    return regex.test(email);
  };

  //hooks
  const isSmallScreen = useMediaQuery("(max-width: 640px)", {
    defaultValue: false,
    initializeWithValue: true,
  });

  //functions
  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e?.target?.value;
    setEmail(value);

    if (value === "") {
      setIsEmailValid(true);
    } else {
      setIsEmailValid(validateEmail(value));
    }
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event?.preventDefault();

    if (!validateEmail(email)) {
      setIsEmailValid(false);
      return;
    }

    onAccept(email);
  };

  useEffect(() => {
    if (!open) setEmail(user?.email ?? "");
  }, [open]);

  return (
    <Modal
      onClose={onCancel}
      isOpen={open}
      slots={{
        container: {
          className: "px-10 py-8 sm:px-6 sm:py-5",
        },
        close: {
          container: {
            className: "mb-0",
          },
          visible: true,
        },
      }}
    >
      <div className="flex flex-col gap-5 sm:flex-row">
        <div className="flex aspect-[130/157] h-[157px] items-center justify-center">
          <Image
            src={getCloudinaryURL(imgURL) ?? NoImageSrc}
            alt={"favorite-i"}
            height={158}
            width={157}
            className="pb-3"
          />
        </div>
        <div className="flex flex-col gap-5">
          <h3 className="max-w-[17rem] text-center text-sm font-semibold sm:text-start sm:text-base">
            {pdpStaticContent?.pdp_notify_when_in_stock_title}
          </h3>
          {/* <div className="flex flex-col gap-4">
            <Checkbox
              className="rounded-[3px] border-2 border-gray-500 bg-white" // Unchecked state
              label="SMS"
              checked={isSmsChecked}
              onChange={handleSmsChecked}
            />
          </div> */}
          <form onSubmit={handleSubmit} className="flex flex-col gap-5">
            <div className="flex flex-col gap-4">
              {/* <Checkbox
                className="rounded-[3px] border-2 border-gray-500 bg-white" // Unchecked state
                label={pdpStaticContent?.pdp_email_checkbox_label}
                checked={isEmailChecked}
                onChange={handleEmailChecked}
              /> */}
              <TextField
                // disabled={!isEmailChecked && true}
                placeholder={pdpStaticContent?.pdp_email_input_label}
                value={email}
                onChange={handleEmailChange}
                slots={{
                  label: { label: pdpStaticContent?.pdp_email_checkbox_label },
                  endAction: { action: !isEmailValid && <Icon src={ErrorSymbol} title={""} /> },
                  error: {
                    variant: "transparent",
                    error: !isEmailValid ? pdpStaticContent?.pdp_invalid_email_address : "",
                  },
                }}
              />
            </div>
            <div className="flex flex-col gap-4 sm:flex-row">
              <Button
                onClick={onCancel}
                className="sm:py-[10px]"
                disabled={isNotifyMeLoading}
                variant={isSmallScreen ? "link" : "contained"}
              >
                {pdpStaticContent?.pdp_cancel_button}
              </Button>
              <Button isLoading={isNotifyMeLoading} className="sm:py-[10px]" type="submit">
                {pdpStaticContent?.pdp_notify_me_button}
              </Button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
};

export default NotifyInStock;
